import { render, staticRenderFns } from "./Targeting.vue?vue&type=template&id=6f5aed87&scoped=true&lang=pug"
import script from "./Targeting.js?vue&type=script&lang=js&external"
export * from "./Targeting.js?vue&type=script&lang=js&external"
import style0 from "./Targeting.vue?vue&type=style&index=0&id=6f5aed87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5aed87",
  null
  
)

export default component.exports